import { formatDate } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment as env } from '@env/environment';
import { HttpHeaders } from '@angular/common/http';
import { AuthenticationService } from '../services/AuthenticationService';
import { IGlobalMessageAdmin, IGlobalMessagePublic, IGlobalMessageUpsertRequest } from '../interfaces/IGlobalMessage';
import { PagedResult } from '../interfaces/IPagedResult';


@Injectable()
export class GlobalMessageService {
    public apiAuthUrl: string;
    private apiBaseUrl: string;
    public token: string;
    private userString: string;
    private httpOptions: any;
    
    constructor(
        private http: HttpClient,
        private router: Router,
        private authenticationService: AuthenticationService,
        private route: ActivatedRoute)
    {
        this.apiBaseUrl = env.hostApi;
        this.setHttpOptions();
    }
    
    getGlobalMessages(appId: number): Observable<IGlobalMessagePublic[]> {
        var url = this.apiBaseUrl + 'GlobalMessage';
        const params = new HttpParams().set('appId', appId.toString());
        return this.http.get<IGlobalMessagePublic[]>(url, {
            headers: this.getHttpHeaders(),
            params
        });
    }

    markAsRead(messageId: number): Observable<any> {
        var url = this.apiBaseUrl + 'GlobalMessage/' + messageId + '/read';
        return this.http.post(url, {}, {
            headers: this.getHttpHeaders()
        });
    }

    getAdminGlobalMessages(page: number = 1, pageSize: number = 25): Observable<PagedResult<IGlobalMessageAdmin>> {
        var url = this.apiBaseUrl + 'admin/globalmessages';
        const params = new HttpParams()
            .set('page', page.toString())
            .set('pageSize', pageSize.toString());

        return this.http.get<PagedResult<IGlobalMessageAdmin>>(url, {
            headers: this.getHttpHeaders(),
            params
        });
    }

    createGlobalMessage(payload: IGlobalMessageUpsertRequest): Observable<IGlobalMessageAdmin> {
        var url = this.apiBaseUrl + 'admin/globalmessages';
        return this.http.post<IGlobalMessageAdmin>(url, this.toCalendarDatePayload(payload), {
            headers: this.getHttpHeaders()
        });
    }

    updateGlobalMessage(id: number, payload: IGlobalMessageUpsertRequest): Observable<IGlobalMessageAdmin> {
        var url = this.apiBaseUrl + 'admin/globalmessages/' + id;
        return this.http.put<IGlobalMessageAdmin>(url, this.toCalendarDatePayload(payload), {
            headers: this.getHttpHeaders()
        });
    }

    setGlobalMessageDisabled(id: number, isDisabled: boolean): Observable<any> {
        var url = this.apiBaseUrl + 'admin/globalmessages/' + id + '/disabled';
        return this.http.patch(url, { isDisabled }, {
            headers: this.getHttpHeaders()
        });
    }

    deleteGlobalMessage(id: number): Observable<any> {
        var url = this.apiBaseUrl + 'admin/globalmessages/' + id;
        return this.http.delete(url, {
            headers: this.getHttpHeaders()
        });
    }

    private toCalendarDatePayload(payload: IGlobalMessageUpsertRequest) {
        return {
            ...payload,
            DateStart: formatDate(payload.DateStart, 'yyyy-MM-dd', 'sv-SE'),
            DateEnd: payload.DateEnd ? formatDate(payload.DateEnd, 'yyyy-MM-dd', 'sv-SE') : null
        };
    }

    setHttpOptions() {
        this.httpOptions = {
            headers: this.getHttpHeaders()
        };
    }

    private getHttpHeaders(): HttpHeaders {
        var bearerToken = 'bearer ' + this.authenticationService.token;
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': bearerToken
        });
    }
}

